import { useState, useEffect, useRef, useCallback } from "react";

/**
 * useMessageInput — tiny state container for a chat input field.
 *
 * Owns the text value, an auto-focus ref, and an onSubmit helper that
 * clears the field after delegating to the caller-supplied ``onSend`` fn.
 *
 * Auto-focuses the input when ``focusKey`` changes (e.g. panel-open toggle).
 */
export default function useMessageInput({ onSend, disabled, focusKey }) {
  const [value, setValue] = useState("");
  const inputRef = useRef(null);

  useEffect(() => {
    if (focusKey && inputRef.current) {
      const h = setTimeout(() => inputRef.current?.focus(), 150);
      return () => clearTimeout(h);
    }
  }, [focusKey]);

  const submit = useCallback((e) => {
    if (e) e.preventDefault();
    const msg = value.trim();
    if (!msg || disabled) return;
    setValue("");
    onSend(msg);
  }, [value, disabled, onSend]);

  return {
    value,
    setValue,
    inputRef,
    submit,
  };
}
